import TipoCnpjFuncao from '@/model/resource/TipoCnpjFuncao'
import {bool, InputType, Schema} from 'simpli-web-sdk'

export default (model: TipoCnpjFuncao): Schema => ({
    idTipoFuncaoPk: {
        content: model.idTipoFuncaoPk,
        editable: false,
    },
    descricao: {
        content: model.descricao,
    },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },
})
